<template>
  <div>

    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/modules">All Courses</router-link>
        </li>
        <li class="is-active">
          <router-link to="/modules/submodules">{{code}}</router-link>
        </li>
      </ul>
    </nav>

    <h1 class="title is-1 mb-0">{{title}}</h1>

    <div class="content mb-6">
      <p>{{copy}}</p>
    </div>

    <div class="box">
      <b-steps mobile-mode="compact" :has-navigation="false" v-model="stepIndex">
        <b-step-item v-for="(module, i) in submodules"
                     :key="`${i}-submodule`"
                     :icon="module.icon"
                     :label="module.shortTitle"
                     clickable>

          <div class="py-4">
            <h1 class="title has-text-centered">{{module.title}}</h1>

            <div class="columns is-centered">
              <div class="column is-6">
                <wistia v-if="module.wistiaVideo && stepIndex === i" :id="module.wistiaVideo" :width="640" :height="361" />
                <you-tube v-else-if="module.youTubeVideoId && stepIndex === i" :vid-id="module.youTubeVideoId" />
              </div>
            </div>

            <div class="has-text-centered">
              <b-button v-if="module.pdfLink" @click="() => downloadPdf(module.pdfLink)" type="is-success" icon-left="file-pdf">Download PDF</b-button>
            </div>
          </div>

        </b-step-item>
      </b-steps>
    </div>
  </div>
</template>

<script>
import Wistia from '@/components/misc/Wistia';
import YouTube from '@/components/misc/YouTube';

export default {
  components: {
    Wistia,
    YouTube
  },
  data() {
    return {
      title: '',
      copy: '',
      submodules: [],
      code: '',
      stepIndex: 0
    }
  },
  mounted() {
    this.submodules = JSON.parse(localStorage.getItem('submodules'));
    this.title = localStorage.getItem('submodulesTitle');
    this.copy = localStorage.getItem('submodulesCopy');
    this.code = localStorage.getItem('submodulesCode');
  },
  methods: {
    downloadPdf: function (pdfLink) {
      window.open(pdfLink, '_blank');
    }
  }
}
</script>